import { businessProposalsService } from '@/services/proposals/business';
import type { BusinessUnderwritingMessagesResponse } from '@/services/quotes/types';
import { useQuery } from '@tanstack/react-query';

export function useProposalUnderwritingMessages(
  policyId: string | undefined,
  enabled = true
) {
  return useQuery<BusinessUnderwritingMessagesResponse>({
    queryKey: ['proposal-underwriting-messages', policyId],
    queryFn: async () => {
      if (!policyId) {
        throw new Error('policyId é obrigatório');
      }

      const response =
        await businessProposalsService.getUnderwritingMessages(policyId);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar mensagens de subscrição'
        );
      }

      return response.data;
    },
    enabled: enabled && Boolean(policyId),
  });
}
